'use client';

import React from 'react';
import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  variant?: 'default' | 'white' | 'muted' | 'primary';
}

const sizeMap = {
  sm: 'h-4 w-4',
  md: 'h-6 w-6', 
  lg: 'h-8 w-8',
  xl: 'h-12 w-12'
};

const variantMap = {
  default: 'text-current',
  white: 'text-white',
  muted: 'text-muted-foreground',
  primary: 'text-primary'
};

export const Spinner: React.FC<SpinnerProps> = ({ 
  size = 'md',
  className,
  variant = 'default'
}) => {
  return (
    <Loader2 
      className={cn(
        'animate-spin',
        sizeMap[size],
        variantMap[variant],
        className
      )} 
    />
  );
};

interface LoadingProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  variant?: 'default' | 'white' | 'muted' | 'primary';
  className?: string;
  fullHeight?: boolean;
}

export const Loading: React.FC<LoadingProps> = ({
  message = 'Loading...',
  size = 'lg',
  variant = 'default',
  className,
  fullHeight = false
}) => {
  return (
    <div className={cn(
      'flex flex-col items-center justify-center gap-3',
      fullHeight ? 'min-h-64' : 'py-8',
      className
    )}>
      <Spinner size={size} variant={variant} />
      {message && (
        <p className="text-sm text-muted-foreground animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
};

interface ButtonSpinnerProps {
  size?: 'sm' | 'md';
  className?: string;
}

export const ButtonSpinner: React.FC<ButtonSpinnerProps> = ({ 
  size = 'sm',
  className 
}) => {
  return (
    <Spinner 
      size={size} 
      className={cn('mr-2', className)} 
    />
  );
};

// Re-export for backward compatibility
export default Spinner;